//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const DEFAULT_TOP_SPARE = 28
const DEFAULT_HEIGHT = 184
export default {
    props: {
        pendant_size: Number,
        headimg_size: Number,
        pendant_url: String,
        headimg_url: String,
        use_open: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        height_radio() {
            return (this.pendant_size / DEFAULT_HEIGHT).toFixed(2)
        },
        headimg_wrap_style() {
            const size = `${this.pendant_size / 2}px`
            return {
                width: size,
                height: size
            }
        },
        head_style() {
            const top = Math.round(DEFAULT_TOP_SPARE * this.height_radio)
            return {
                top: `${top / 2}px`
            }
        },
        img_style() {
            const size = `${this.headimg_size / 2}px`
            return {
                width: size,
                height: size
            }
        }
    },
}
